import React, { useState } from 'react';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

import { Avatar } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Container } from '../../../../symphony';

import { SlDiscussContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { UserDetailsBadge } from '../../../../shared/public/UserDetailsBadge/UserDetailsBadge';

import s from './Meta.scss';

interface IMetaProps {
	date: string;
	avatarUrl: string;
	userName: string;
	userID: number;
	badge: string;
}

dayjs.extend(advancedFormat);

export function Meta({
	date, avatarUrl, userName, userID, badge
}: IMetaProps) {
	useStyles(s);
	const { actions$ } = Container.take(SlDiscussContext, SlActions);
	const [avatarUrlState, setAvatarUrlState] = useState<string | null>(
		avatarUrl,
	);
	const onAvatarLoadError = () => setAvatarUrlState(null);
	const profileClickHandler = () => {
		actions$.next({
			type: ActionType.OnProfileButtonClick,
			requestType: RequestType.Parallel,
			data: {
				userId: userID,
			},
		});
	};

	return (
		<div className="discuss-meta">
			<div className="discuss-meta__info">
				<div className="discuss-meta__info__date">
					{dayjs(date).format('Do MMM YYYY, h:mm A').toString()}
				</div>
				<div
					onClick={profileClickHandler}
					className="discuss-meta__info__name"
				>
					{userName}
				</div>
			</div>
			{avatarUrlState ? (
				<div
					className='discuss-meta__avatar-container'
					onClick={profileClickHandler}
				>
					<img
						src={avatarUrlState}
						alt={`${userName} - avatar`}
						className="discuss-meta__avatar"
						onError={onAvatarLoadError}
						loading="lazy"
					/>
					<UserDetailsBadge
						badgeString={badge}
						styles={{
							mentor: {
								fontSize: '10px',
								marginTop: '-6px'
							},
							subscription: {
								fontSize: '12px',
								marginTop: '-8px'
							},
							experience: {
								fontSize: '10px',
								marginLeft: "12px",
								marginTop: "-12px"
							}
						}}
						mentorLabel='M'
					/>
				</div>
			) : (
				<div onClick={profileClickHandler}>
					<Avatar
						className="discuss-meta__avatar"
						onClick={profileClickHandler}
					/>
				</div>
			)}
		</div>
	);
}
